import { Routes } from '@angular/router';
import { ShellComponent } from './layout/shell/shell.component';
import { tokenCaptureGuard } from './core/auth/token-capture.guard';

export const routes: Routes = [
  {
    path: 'login',
    loadComponent: () =>
      import('./modules/login/login.component').then(m => m.LoginComponent),
    title: 'Login',
  },

  // Rota usada pelo pdf-service (Puppeteer) para renderizar o extrato
  {
    path: 'extrato-excedente-pdf/:id',
    loadComponent: () =>
      import('./modules/gestao/consumo-excedente/components/consumo-excedente-pdf/consumo-excedente-pdf.component')
        .then(m => m.ConsumoExcedentePdfComponent),
    title: 'Extrato Excedente PDF',
  },




  {
    path: '',
    canActivate: [tokenCaptureGuard],
    component: ShellComponent,
    children: [
      
      { path: '', pathMatch: 'full', redirectTo: 'dashboard' },

      {
        path: 'dashboard',
        loadComponent: () =>
          import('./modules/home/home.component').then(m => m.HomeComponent),
        title: 'Dashboard',
        data: { breadcrumb: 'Dashboard' }
      },

      {
        path: 'ajuda',
        loadComponent: () =>
          import('./modules/ajuda/ajuda.component').then(m => m.AjudaComponent),
        title: 'Ajuda',
        data: { breadcrumb: 'Ajuda' }
      },
      {
        path: 'release-notes',
        loadComponent: () =>
          import('./modules/release-notes/release-notes.component').then(m => m.ReleaseNotesComponent),
        title: 'Release Notes',
        data: { breadcrumb: 'Release Notes' }
      },
      
    { path: 'gestao-contratos',   
      loadChildren: () => import('./modules/gestao/contratado/contratado.routes').then(m => m.CONTRATADO_ROUTES) 
    },
    { path: 'gestao-consumos',   
      loadChildren: () => import('./modules/gestao/consumo-excedente/consumo-excedente.routes').then(m => m.CONSUMO_EXCEDENTE_ROUTES) 
    },
    { path: 'status-processamento',   
      loadChildren: () => import('./modules/gestao/status-processamento/status-processamento.routes').then(m => m.STATUS_PROCESSAMENTO_ROUTES) 
    },
    { path: 'sincronismo-processamento-manual',   
      loadChildren: () => import('./modules/gestao/sincronismo-processamento-manual/sincronismo-processamento.manual.routes').then(m => m.SINCRONISMO_PROCESSAMENTO_MANUAL_ROUTES)
    },
    { path: 'configuracoes-agendamento',   
      loadChildren: () => import('./modules/configuracoes/configuracoes-agendamento/configuracoes-agendamento.routes').then(m => m.CONFIGURACOES_AGENDAMENTO_ROUTES) 
    },
    { path: 'configuracoes-gerais',   
      loadChildren: () => import('./modules/configuracoes/configuracoes-gerais/configuracoes-gerais.routes').then(m => m.CONFIGURACOES_GERAIS_ROUTES) 
    },
   { path: 'contas-tabs',   
      loadChildren: () => import('./modules/gestao/contas/pages/contas-tab.routes').then(m => m.CONTAS_TAB_ROUTES) 
    },
    { path: 'conta-mestre',   
      loadChildren: () => import('./modules/gestao/contas/conta-mestre/conta-mestre.routes').then(m => m.CONTA_MESTRE_ROUTES) 
    },
    { path: 'cliente-mestre',   
      loadChildren: () => import('./modules/gestao/contas/cliente-mestre/cliente-mestre.routes').then(m => m.CLIENTE_MESTRE_ROUTES) 
    },
    { path: 'extrato-cliente',   
      loadChildren: () => import('./modules/gestao/extrato-cliente/extrato-cliente.routes').then(m => m.EXTRATO_CLIENTE_ROUTES) 
    },
    { path: 'consumo-consolidado',   
      loadChildren: () => import('./modules/gestao/consumo-consolidado/consumo-consolidado.routes').then(m => m.CONSUMO_CONSOLIDADO_ROUTES) 
    },
    { path: 'sensedata-customer',   
      loadChildren: () => import('./modules/api-externa/sensedata/sensedata.routes').then(m => m.SENSEDATA_ROUTES) 
    },
    { path: 'notificacoes',   
      loadChildren: () => import('./modules/notificacoes/notificacoes.routes').then(m => m.NOTIFICACOES_ROUTES) 
    },

    ]
  },

  // 404
  { path: '**', redirectTo: 'dashboard' }
];
